/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatChannelNameUpdateRequest
 */
export interface ChatChannelNameUpdateRequest {
    /**
     * The new name for this chat channel
     * @type {string}
     * @memberof ChatChannelNameUpdateRequest
     */
    name: string;
}

/**
 * Check if a given object implements the ChatChannelNameUpdateRequest interface.
 */
export function instanceOfChatChannelNameUpdateRequest(value: object): value is ChatChannelNameUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ChatChannelNameUpdateRequestFromJSON(json: any): ChatChannelNameUpdateRequest {
    return ChatChannelNameUpdateRequestFromJSONTyped(json, false);
}

export function ChatChannelNameUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannelNameUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function ChatChannelNameUpdateRequestToJSON(json: any): ChatChannelNameUpdateRequest {
    return ChatChannelNameUpdateRequestToJSONTyped(json, false);
}

export function ChatChannelNameUpdateRequestToJSONTyped(value?: ChatChannelNameUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

